/**
 * LandingPage — Cinematic editorial scroll experience.
 *
 *   Hero with "DAGGPT" wordmark and the second "P" opening on scroll
 *   to reveal a Three.js glass blockchain artifact. Lenis-driven
 *   smooth scroll with GSAP ScrollTrigger choreography.
 */
import React, { useEffect } from 'react';
import { useLenis } from './landing/useLenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { HeroA_Product } from './landing/HeroA_Product';
import { HeroStory } from './landing/HeroStory';
import {
  ManifestoSection,
  CapabilitiesSection,
  ModelsSection,
  ProvenanceSection,
  HowItWorksSection,
  NumbersSection,
  CtaFooterSection,
  GpuSection,
} from './landing/LandingSections';
import { CinematicBackground } from './ui/CinematicBackground';

export const LandingPage = React.memo(function LandingPage({ onSignInClick }) {
  useLenis();

  useEffect(() => {
    // React's bottom-up useEffect execution means ModelsSection creates its pin before HeroStory.
    // We must manually sort and refresh ScrollTriggers so positions are calculated correctly.
    const t = setTimeout(() => {
      ScrollTrigger.sort();
      ScrollTrigger.refresh();
    }, 200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{
      background: 'transparent',
      color: '#FFFFFF',
      fontFamily: '"Inter", system-ui, sans-serif',
      WebkitFontSmoothing: 'antialiased',
    }}>
      <CinematicBackground />

      <HeroStory onSignInClick={onSignInClick} />
      <HeroA_Product onSignInClick={onSignInClick} />
      <ManifestoSection />
      <CapabilitiesSection />
      <ModelsSection onSignInClick={onSignInClick} />
      <ProvenanceSection onSignInClick={onSignInClick} />
      <GpuSection />
      <HowItWorksSection />
      <NumbersSection />
      <CtaFooterSection onSignInClick={onSignInClick} />
    </div>
  );
});
